import type { AddCohortFormValues } from './types/general';

export const COHORT_FIELD_KEYS = {
  NAME: 'name',
  SERVICE_CLASSES: 'service_classes',
} as const;

export const ADD_COHORT_FORM_INITIAL_VALUES: AddCohortFormValues = {
  [COHORT_FIELD_KEYS.NAME]: '',
  [COHORT_FIELD_KEYS.SERVICE_CLASSES]: [],
};

export const CHOOSE_SERVICE_CLASS_PLACEHOLDER = 'Choose service class';
